import script from "./Sharing.vue?vue&type=script&setup=true&lang=js"
export * from "./Sharing.vue?vue&type=script&setup=true&lang=js"

import "./Sharing.vue?vue&type=style&index=0&id=12dbc5a3&lang=scss"

const __exports__ = script;

export default __exports__